import { ColorEnum } from '@/constants/color'
import { useRouterCanGoBackParamSubscriber } from '@/features/navigation/hooks/can-go-back'
import CashTransactionForm from '@/features/shiftCloseouts/components/CashTransactionForm'
import CashTransactionHistory from '@/features/shiftCloseouts/components/CashTransactionHistory'
import CashTransactionsHeader from '@/features/shiftCloseouts/components/CashTransactionsHeader'
import { useCashTransactions } from '@/features/shiftCloseouts/hooks/useCashTransactions'
import { useScreenLayout } from '@/hooks/screen'
import { useRouter } from 'expo-router'
import { FC } from 'react'
import { ActivityIndicator, ScrollView, View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

const CashTransactionsPage: FC = () => {
    const { styles } = useStyles(stylesheet)
    const layout = useScreenLayout()
    const router = useRouter()
    const { currency, deposit, loading, totals, transactions, withdrawal } = useCashTransactions()

    useRouterCanGoBackParamSubscriber()

    if (!currency || !totals) {
        return (
            <View style={[styles.container, styles.loading]}>
                {loading && <ActivityIndicator />}
            </View>
        )
    }

    return (
        <View style={styles.container}>
            <ScrollView
                contentContainerStyle={styles.scrollContent}
                keyboardShouldPersistTaps="always"
                showsVerticalScrollIndicator={false}
            >
                <CashTransactionsHeader
                    layout={layout}
                    onBack={() => router.dismissTo('/shift-closeouts')}
                    totals={totals}
                />
                <View style={styles.content}>
                    <CashTransactionForm
                        currency={currency}
                        deposit={deposit}
                        layout={layout}
                        withdrawal={withdrawal}
                    />
                    <CashTransactionHistory layout={layout} transactions={transactions} />
                </View>
            </ScrollView>
        </View>
    )
}

const stylesheet = createStyleSheet((_, { insets }) => ({
    container: {
        flex: 1,
        backgroundColor: ColorEnum.WHITE,
    },
    loading: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    scrollContent: {
        flexGrow: 1,
        paddingBottom: insets.bottom,
    },
    content: {
        gap: 32,
        padding: 16,
        paddingLeft: 16 + insets.left,
        paddingRight: 16 + insets.right,
    },
}))

export default CashTransactionsPage
